import { createRoot } from "@wordpress/element";
import App from "./components/App";

document
	.querySelectorAll(".wp-block-app-description-app-description")
	.forEach((el) => {
		const root = el.querySelector(".app-description__app");
		if (root) {
			createRoot(root).render(<App />);
		}
	});
